import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import withLoader from 'components/organisms/withLoader';
import { scrollToErrorIfExist, showResult } from 'utils';
import Button from 'components/atoms/button';
import { Formik, Form } from 'formik';
import { Card, CardBody } from 'reactstrap';
import validationSchema from 'components/organisms/adminPanels/clinics/threshold/validationSchema';
import requestBodyGenerator from 'components/organisms/adminPanels/clinics/threshold/requestBodyGenerator';
import Threshold from 'components/organisms/adminPanels/clinics/components/threshold';
import { useHistory } from 'react-router-dom';

const EditClinicThreshold = ({ clinicGuid }) => {
  const {
    adminPanelClinics: { editThreshold },
  } = useDispatch();
  const clinicThreshold = useSelector(
    (state) => state.adminPanelClinics.threshold,
  );
  const history = useHistory();

  const {
    getThreshold: thresholdLoading,
    getClinic: clinicDetailsLoading,
    getRepresentatives: representativesLoading,
    getAgencies: agenciesLoading,
    editThreshold: submitLoading,
  } = useSelector((state) => state.loading.effects.adminPanelClinics);

  const submitHandler = async (clinicRequest) => {
    const body = requestBodyGenerator({ ...clinicRequest, clinicGuid });
    const { error, data } = await editThreshold(body);
    if (error) return showResult(error);
    showResult();
    history.push(`/admin/clinic/${data.clinicGuid}`);
  };

  return (
    <div className="admin-patient">
      {withLoader(
        clinicDetailsLoading ||
          representativesLoading ||
          thresholdLoading ||
          agenciesLoading,
        <Card className="card-border">
          {clinicThreshold && (
            <CardBody>
              <Formik
                onSubmit={submitHandler}
                initialValues={{ ...clinicThreshold }}
                validationSchema={validationSchema}
              >
                {({ errors, values }) => (
                  <Form>
                    <div className="admin-patient-edit-form">
                      <Threshold values={values} errors={errors} />
                    </div>
                    <div className="text-center">
                      <Button
                        disabled={submitLoading && errors}
                        type="submit"
                        text="Save"
                        handleClick={scrollToErrorIfExist}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          )}
        </Card>,
      )}
    </div>
  );
};

EditClinicThreshold.propTypes = {
  clinicGuid: PropTypes.string,
};

export default EditClinicThreshold;
